import { motion } from 'framer-motion';
import styled from 'styled-components';

export const HomePageWrapper = styled(motion.div)``;
